import { render } from "./TaxiReservationSuggest.vue?vue&type=template&id=3fb2c2ad&scoped=true"
import script from "./TaxiReservationSuggest.vue?vue&type=script&lang=js"
export * from "./TaxiReservationSuggest.vue?vue&type=script&lang=js"

import "./TaxiReservationSuggest.vue?vue&type=style&index=0&id=3fb2c2ad&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb2c2ad"]])

export default __exports__